
export function normalize (arr) {
  const obj = {}
  arr.forEach(({
    id,
    ...attrs
  }) => (obj[id] = Object.assign({}, attrs, {
    id
  })))

  return obj
}

export function normalizeCustomProperty (arr, property) {
  const obj = {}
  arr.forEach(({
    ...attrs
  }, index) => (obj[arr[index][property]] = attrs))
  return obj
}

export function denormalize (obj) {
  const arr = []
  const objKeys = Object.keys(obj)
  objKeys.map((objKey, index) => {
    arr[arr.length] = obj[objKey]
  })
  return arr
}
